import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// Edge Function 호출 (JWT 인증) — BillingApi.callFn과 동일 패턴
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // 치지직 동의 시작 → 동의 URL 받아서 전체 페이지 이동 (네이버 로그인/동의 화면)
  async start() {
    const { authorizeUrl } = await callFn("/signaling/chzzk/oauth/start");
    if (!authorizeUrl) throw new Error("E_NO_AUTHORIZE_URL");
    window.location.assign(authorizeUrl);
  },
  // 연동 해제 — Edge가 토큰 revoke(client_secret) + platform_oauth 행 삭제 + enabled off.
  async disconnect() {
    return await callFn("/signaling/chzzk/oauth/disconnect");
  },
};
